import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdContentBlocksIdPreviewThumbnail } from "./constants";
import type {
  GetEngagementAppGroupIdContentBlocksIdPreviewThumbnailProps,
  GetEngagementAppGroupIdContentBlocksIdPreviewThumbnailResult,
} from "./types";
import { isGetEngagementAppGroupIdContentBlocksIdPreviewThumbnailResult } from "./validators";

/**
 * GET handler for the "/engagement/:app_group_id/content_blocks/:id/preview_thumbnail" endpoint
 */
export const getEngagementAppGroupIdContentBlocksIdPreviewThumbnail = reactQueryFetcherAdapter(
  engagementAppGroupIdContentBlocksIdPreviewThumbnail,
  (
    signal: AbortSignal,
    { appGroupId, id, previewVersion }: GetEngagementAppGroupIdContentBlocksIdPreviewThumbnailProps
  ): Promise<GetEngagementAppGroupIdContentBlocksIdPreviewThumbnailResult> => {
    return fetch(
      `/engagement/${appGroupId}/content_blocks/${id}/preview_thumbnail`,
      "GET",
      { v: previewVersion },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetEngagementAppGroupIdContentBlocksIdPreviewThumbnailResult
);
